import React from "react";
import { Link } from "react-router-dom";

const headingClass =
  "m-0 mb-4 font-sans text-sm font-semibold uppercase text-[#333333] tracking-normal";
const linkClass =
  "font-sans text-[14px] leading-5 font-light text-[#333333] hover:text-brand no-underline";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-300 font-sans font-light text-[#333333]">
      <div className="bg-[#fbfbfb]">
        <div className="max-w-[1440px] mx-auto px-8 xl:px-14 pt-6 pb-12">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-10">
            <div>
              <p className={headingClass}>About Inari</p>
              <ul className="list-none m-0 p-0">
                <li className="mt-0">
                  <Link to="/aboutUs" className={linkClass}>About Us</Link>
                </li>
                <li className="mt-3">
                  <Link to="/contactUs" className={linkClass}>Contact Us</Link>
                </li>
                <li className="mt-3">
                  <Link to="/login" className={linkClass}>Become a Seller</Link>
                </li>
                <li className="mt-3">
                  <Link to="/new-arrivals" className={linkClass}>New Arrivals</Link>
                </li>
              </ul>
            </div>

            <div>
              <p className={headingClass}>Buying Guide</p>
              <ul className="list-none m-0 p-0">
                <li>
                  <Link to="/faqs" className={linkClass}>FAQs</Link>
                </li>
                <li className="mt-3">
                  <Link to="/shipping-policy" className={linkClass}>Shipping & Delivery</Link>
                </li>
                <li className="mt-3">
                  <Link to="/return-policy" className={linkClass}>Cancellations, Returns & Exchanges</Link>
                </li>
                <li className="mt-3">
                  <Link to="/faqs" className={linkClass}>Size Guide</Link>
                </li>
                <li className="mt-3">
                  <Link to="/account/order" className={linkClass}>Track Your Order</Link>
                </li>
              </ul>
            </div>

            <div>
              <p className={headingClass}>Account</p>
              <ul className="list-none m-0 p-0">
                <li>
                  <Link to="/account" className={linkClass}>Account Details</Link>
                </li>
                <li className="mt-3">
                  <Link to="/account/order" className={linkClass}>Orders & Returns</Link>
                </li>
                <li className="mt-3">
                  <Link to="/account/wishlist" className={linkClass}>Wishlist</Link>
                </li>
                <li className="mt-3">
                  <Link to="/cart" className={linkClass}>Bag</Link>
                </li>
              </ul>
            </div>

            <div>
              <p className={headingClass}>Policies</p>
              <ul className="list-none m-0 p-0">
                <li>
                  <Link to="/terms-condition" className={linkClass}>Terms & Conditions</Link>
                </li>
                <li className="mt-3">
                  <Link to="/privacy-policy" className={linkClass}>Security & Privacy</Link>
                </li>
                <li className="mt-3">
                  <Link to="/shipping-policy" className={linkClass}>Shipping Policy</Link>
                </li>
                <li className="mt-3">
                  <Link to="/return-policy" className={linkClass}>Return Policy</Link>
                </li>
              </ul>
            </div>

            <div>
              <p className={headingClass}>Contact Us</p>
              <ul className="list-none m-0 p-0 font-sans text-[14px] leading-5 font-light text-[#333333]">
                <li>
                  <a href="tel:+918076834935" className={linkClass}>Toll Free: 8076834935</a>
                </li>
                <li className="mt-3">(Mon-Fri 10am-10pm IST)</li>
                <li className="mt-3">
                  <a
                    href="https://wa.me/918076834935"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={linkClass}
                  >
                    Whatsapp: +91 8076834935
                  </a>
                </li>
                <li className="mt-3">
                  <a href="mailto:info@inari.com" className={linkClass}>info@inari.com</a>
                </li>
              </ul>

              <div className="mt-[30px]">
                <p className={headingClass}>We Accept</p>
                <div className="flex flex-wrap gap-2">
                  {["VISA", "Mastercard", "RuPay", "UPI"].map((method) => (
                    <span
                      key={method}
                      className="inline-flex items-center justify-center px-2 py-1 border border-gray-300 bg-white text-[11px] leading-4 text-[#333333]"
                    >
                      {method}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-[30px]">
                <p className={headingClass}>Follow Us</p>
                <div className="flex items-center gap-4">
                  <a href="#" aria-label="Facebook" className="text-[#333333] hover:text-brand">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                    </svg>
                  </a>
                  <a href="#" aria-label="Instagram" className="text-[#333333] hover:text-brand">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" />
                    </svg>
                  </a>
                  <a href="#" aria-label="Pinterest" className="text-[#333333] hover:text-brand">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853C9.003 23.29 10.47 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <div className="hidden lg:block w-auto max-w-[290px]">
              <p className="mb-5 text-sm font-semibold uppercase text-[#333333] text-left">
                Download the Inari app
              </p>
              <div className="flex flex-col gap-3">
                <a
                  href="#"
                  className="inline-flex items-center bg-black text-white px-3 py-2 no-underline"
                >
                  <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  <span className="text-left">
                    <span className="block text-[10px] leading-3 font-light">Download on the</span>
                    <span className="block text-sm font-semibold">App Store</span>
                  </span>
                </a>
                <a
                  href="#"
                  className="inline-flex items-center bg-black text-white px-3 py-2 no-underline"
                >
                  <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 20.5V3.5c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85C3.34 21.6 3 21.09 3 20.5m13.81-5.38L6.05 21.34l8.49-8.49 2.27 2.27m3.35-4.31c.34.27.59.69.59 1.19s-.22.9-.57 1.18L17.89 14.5 15.39 12l2.5-2.5 2.27 1.31M6.05 2.66l10.76 6.22-2.27 2.27L6.05 2.66z" />
                  </svg>
                  <span className="text-left">
                    <span className="block text-[10px] leading-3 font-light">GET IT ON</span>
                    <span className="block text-sm font-semibold">Google Play</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="max-w-[1440px] mx-auto px-8 xl:px-14 py-6 text-[#707070] text-[13px] leading-[19.5px] font-light text-justify">
          <p className="m-0 mb-3">
            Inari Fashions is a curated designer destination for wedding, festive and everyday luxury
            for women, men and kids. Discover collections from independent and established Indian
            designers, with pieces chosen for craft, occasion and ease of wear.
          </p>
          <p className="m-0">
            From occasion wear and ready-to-ship styles to jewellery and accessories, shop a
            thoughtfully edited mix of traditional and contemporary looks — with support from our
            team when you need it.
          </p>
        </div>
      </div>

      <div className="bg-[#fbfbfb]">
        <div className="max-w-[1440px] mx-auto px-8 xl:px-14 py-3">
          <p className="m-0 text-xs font-light text-[#86847d]">
            Copyright © 2026 INARI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
